import { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

export const LANGUAGES = {
  en: { code: "en", name: "English", flag: "🇬🇧" },
  fr: { code: "fr", name: "Français", flag: "🇫🇷" },
  es: { code: "es", name: "Español", flag: "🇪🇸" },
};

const detectBrowserLanguage = () => {
  // Get browser language (e.g., "fr-FR", "en-US", "es-ES")
  const browserLang = navigator.language || navigator.userLanguage || "en";
  // Extract the base language code (e.g., "fr", "en", "es")
  const baseLang = browserLang.split("-")[0].toLowerCase();
  
  // Return the language if supported, otherwise default to English
  if (LANGUAGES[baseLang]) {
    return baseLang;
  }
  return "en";
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // First check if user has a saved preference
    const saved = localStorage.getItem("cayus-language");
    if (saved && LANGUAGES[saved]) {
      return saved;
    }
    // Otherwise detect from browser
    return detectBrowserLanguage();
  });

  useEffect(() => {
    localStorage.setItem("cayus-language", language);
    document.documentElement.lang = language;
  }, [language]);

  const switchLanguage = (lang) => {
    if (LANGUAGES[lang]) {
      setLanguage(lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, switchLanguage, LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
